import { alpha } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  card: {
    width: '100%',
    maxWidth: 400,
    marginInline: 'auto',
    border: `1px solid ${theme.palette.border.default}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.surface.raised,
    overflow: 'hidden',
  },
  header: {
    padding: theme.spacing(1.5),
  },
  icon: {
    display: 'grid',
    placeItems: 'center',
    width: 42,
    height: 42,
    flexShrink: 0,
    borderRadius: '50%',
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    color: theme.palette.primary.main,
  },
  externalIcon: {
    backgroundColor: alpha(theme.palette.purple.A100, 0.12),
    color: theme.palette.purple.A100,
  },
  titleContainer: {
    minWidth: 0,
    flex: 1,
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
  },
  toolName: {
    marginTop: theme.spacing(0.25),
    color: theme.palette.text.secondary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  status: {
    flexShrink: 0,
    color: theme.palette.status.danger.foreground,
    backgroundColor: theme.palette.status.danger.background,
    fontWeight: theme.typography.fontWeightBold,
    '& .MuiChip-label': { paddingInline: theme.spacing(1.25) },
  },
  completedStatus: {
    color: theme.palette.status.success.foreground,
    backgroundColor: theme.palette.status.success.background,
  },
  cancelledStatus: {
    color: theme.palette.status.neutral.foreground,
    backgroundColor: theme.palette.status.neutral.background,
  },
  divider: {
    marginInline: theme.spacing(1.5),
    borderColor: theme.palette.border.default,
  },
  detailsButton: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.06) },
  },
  detailsButtonContent: {
    padding: theme.spacing(1.5),
  },
  detailsButtonLabel: {
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  details: {
    paddingInline: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  fieldLabel: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightBold,
  },
  fieldValue: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.primary,
  },
  output: {
    margin: 0,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1),
    maxHeight: 140,
    overflow: 'auto',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.surface.sunken,
    color: theme.palette.text.primary,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  errorOutput: {
    color: theme.palette.status.danger.foreground,
  },
  description: {
    color: theme.palette.text.secondary,
  },
  value: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
  },
  rawValue: {
    margin: 0,
    color: theme.palette.text.primary,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  nestedObject: {
    marginTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(1.25),
    borderLeft: `2px solid ${theme.palette.border.default}`,
  },
  array: {
    marginTop: theme.spacing(0.5),
  },
  scalarChip: {
    maxWidth: '100%',
    color: theme.palette.text.primary,
    borderColor: theme.palette.border.strong,
  },
  moreScalars: {
    alignSelf: 'center',
    color: theme.palette.text.secondary,
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
  rawDetails: {
    marginTop: theme.spacing(0.5),
  },
  rawSummary: {
    fontFamily: theme.typography.body2.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
    letterSpacing: theme.typography.body2.letterSpacing,
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightBold,
    '&:hover': { color: theme.palette.text.primary },
  },
  rawJson: {
    fontFamily: theme.typography.body2.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
    lineHeight: theme.typography.body2.lineHeight,
    letterSpacing: theme.typography.body2.letterSpacing,
    margin: 0,
    marginTop: theme.spacing(0.75),
    padding: theme.spacing(1),
    maxHeight: 140,
    overflow: 'auto',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.surface.sunken,
    color: theme.palette.text.primary,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
}));
